import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Box } from "../../../../Box/index.js";
import { Typography } from "../../../../Typography/index.js";
import { getAllTextContent } from "../../utils/index.js";
const CharacterLimitPlugin = (t0)=>{
    const $ = c(21);
    const { limit, descriptionComponent } = t0;
    const [editor] = useLexicalComposerContext();
    const [charsLength, setCharsLength] = useState(0);
    const remainingChars = limit - charsLength;
    const charLimitAvailable = remainingChars >= 0;
    let t1;
    if ($[0] !== editor) {
        t1 = ()=>{
            const removeUpdateListener = editor.registerUpdateListener((t2)=>{
                const { editorState } = t2;
                editorState.read(()=>{
                    const textContent = getAllTextContent(editorState);
                    const currentLength = textContent.length;
                    setCharsLength(currentLength);
                });
            });
            return ()=>{
                removeUpdateListener();
            };
        };
        $[0] = editor;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== editor || $[3] !== limit) {
        t2 = [
            editor,
            limit
        ];
        $[2] = editor;
        $[3] = limit;
        $[4] = t2;
    } else t2 = $[4];
    useEffect(t1, t2);
    if (!charLimitAvailable) {
        const t3 = `Превышено допустимое количество символов: ${limit}. Сократите текст`;
        let t4;
        if ($[5] !== t3) {
            t4 = /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "accent.text.error",
                children: t3
            });
            $[5] = t3;
            $[6] = t4;
        } else t4 = $[6];
        let t5;
        if ($[7] !== remainingChars) {
            t5 = /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "accent.text.error",
                children: remainingChars
            });
            $[7] = remainingChars;
            $[8] = t5;
        } else t5 = $[8];
        let t6;
        if ($[9] !== t4 || $[10] !== t5) {
            t6 = /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    t4,
                    t5
                ]
            });
            $[9] = t4;
            $[10] = t5;
            $[11] = t6;
        } else t6 = $[11];
        return t6;
    }
    let t3;
    if ($[12] !== descriptionComponent) {
        t3 = descriptionComponent || /*#__PURE__*/ jsx(Typography, {
            variant: "caption",
            color: "text.light.secondary",
            children: "Количество символов ограничено"
        });
        $[12] = descriptionComponent;
        $[13] = t3;
    } else t3 = $[13];
    const t4 = descriptionComponent ? "accent.text.error" : "text.light.secondary";
    let t5;
    if ($[14] !== charsLength || $[15] !== limit || $[16] !== t4) {
        t5 = /*#__PURE__*/ jsxs(Typography, {
            variant: "caption",
            color: t4,
            children: [
                charsLength,
                " / ",
                limit
            ]
        });
        $[14] = charsLength;
        $[15] = limit;
        $[16] = t4;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== t3 || $[19] !== t5) {
        t6 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            children: [
                t3,
                t5
            ]
        });
        $[18] = t3;
        $[19] = t5;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
};
export { CharacterLimitPlugin };
